var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBestSellerThird = function SvgBestSellerThird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BestSellerThird_svg__a)",
    d: "M0 3.5A3.5 3.5 0 0 1 3.5 0h29A3.5 3.5 0 0 1 36 3.5v38.74a1.75 1.75 0 0 1-2.497 1.582L0 28.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BestSellerThird_svg__b)",
    d: "M0 3.5A3.5 3.5 0 0 1 3.5 0h29A3.5 3.5 0 0 1 36 3.5v24.519L2.497 43.822A1.75 1.75 0 0 1 0 42.24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.435 21.676a5.4 5.4 0 0 1-.764 2.793 5.65 5.65 0 0 1-2.03 2.03 5.4 5.4 0 0 1-2.77.741 5.4 5.4 0 0 1-2.815-.764 5.8 5.8 0 0 1-2.05-2.05 5.46 5.46 0 0 1-.742-2.771l2.727.021q0 .372.022.568l.065.262q.263.915 1.026 1.505a2.95 2.95 0 0 0 1.767.567q.786 0 1.44-.392.676-.393 1.047-1.07.393-.675.393-1.483 0-.742-.327-1.397a3.2 3.2 0 0 0-.96-1.134q-.568-.393-1.353-.48-.764-.11-2.335-.11v-2.4l3.6-3.73h-6.502V9.96h9.95v2.378l-3.71 3.906q1.2.24 2.182 1.047a5.5 5.5 0 0 1 1.571 1.942q.567 1.155.567 2.443"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "BestSellerThird_svg__a",
    x1: 22.875,
    x2: 31.479,
    y1: 30.991,
    y2: 45.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09F62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BestSellerThird_svg__b",
    x1: 7.875,
    x2: 26.056,
    y1: 0,
    y2: 35.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.089,
    stopColor: "#FADBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#EFA167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#EC8D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1A76B"
  })))));
};
export default SvgBestSellerThird;